module.exports = __webpack_public_path__ + "img/icon_work.4aa2a5e5.png";